<template lang="pug">
div
  el-row
    el-col(:span="24")
      app-resumo-cadastrante(:cadastrante="cadastro.cadastrante")
      app-resumo-interessado(
        :interessado="cadastro.interessado",
        :hasConjuge="true"
        :idCadastro="idCadastro"
      )
      app-resumo-imovel(v-if="cadastro" :imovel="cadastro.imovel" :idCadastro="idCadastro", :hasFieldsExtras="false")
      app-resumo-geo(:geo="cadastro.georreferenciamento", :idCadastro="idCadastro")

</template>
<script>
import AppResumoCadastrante from '@/components/resumo/AppResumoCadastrante'
import AppResumoInteressado from '@/components/resumo/AppResumoInteressado'
import AppResumoImovel from '@/components/resumo/AppResumoImovel'
import AppResumoGeo from '@/components/resumo/AppResumoGeo.vue'

import AppButton from '@/components/shared/AppButton'

export default {
  components: {
    AppButton,
    AppResumoCadastrante,
    AppResumoInteressado,
    AppResumoImovel,
    AppResumoGeo
  },

  props: ['cadastro', 'idCadastro']
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/resgateAforamento/components/Resumo.vue